import UserService from '../../../services/UserService';

export default {
    namespaced: true,
    state: () => ({
        userRolesGroups: [],
        rolesList: [],
    }),
    getters: {
        getUserRolesGroups: (state) => state.userRolesGroups,
    },
    mutations: {
        setUserRolesGroups: (state, userRolesGroups) => {
            state.userRolesGroups = userRolesGroups
        },
        setRolesList: (state, rolesList) => {
            state.rolesList = rolesList
        },
    },
    actions: {
        /**
         * Sisteme yeni bir rol ekler
         */
        addUserRole: ({dispatch}, roleData) => {
            return new Promise((resolve) => {
                UserService.addUserRole(roleData).then(res => {
                    dispatch('getRolesList', res.data)
                    resolve(res)
                }).catch((err) => {
                    console.error(err)
                })
            })
        },
        /**
         *  Sisteme yeni bir rol grubu ekler
         */
        addRoleGroup: ({dispatch}, userRoles) => {
            return new Promise((resolve) => {
                UserService.addRoleGroup(userRoles).then(res => {
                    dispatch('getRolesGroups')
                    resolve(res)
                }).catch((err) => {
                    console.error(err)
                })
            })
        },
        /**
         *  Sisteme yeni bir rol grubu ekler
         */
        editRoleGroup: ({dispatch}, roleGroupData) => {
            return new Promise((resolve) => {
                UserService.editRoleGroup(roleGroupData).then(res => {
                    dispatch('getRolesGroups')
                    resolve(res)
                }).catch((err) => {
                    console.error(err)
                })
            })
        },
        /**
         *  Sisteme yeni bir rol grubu ekler
         */
        deleteRoleGroup: ({dispatch}, id) => {
            return new Promise((resolve) => {
                UserService.deleteRoleGroup(id).then(res => {
                    dispatch('getRolesGroups')
                    resolve(res)
                }).catch((err) => {
                    console.error(err)
                })
            })
        },
        editRole: ({dispatch}, roleData) => {
            return new Promise((resolve) => {
                UserService.editRole(roleData).then(res => {
                    dispatch('getRolesList', res.data)
                    resolve(res)
                }).catch((err) => {
                    console.error(err)
                })
            })
        },
        /**
         * Ekleme yapılan listenin tamamını getirir
         */
        getRolesList: ({commit}, userRoles) => {
            return new Promise((resolve) => {
                UserService.getRolesList(userRoles).then(res => {
                    commit('setRolesList', res.data)
                    resolve(res)
                }).catch((err) => {
                    console.error(err)
                })
            })
        },
        /**
         * Kullanıcı rol gruplarını getir
         */
        getRolesGroups: ({commit}) => {
            return new Promise((resolve) => {
                UserService.getRolesGroups().then(res => {
                    commit('setUserRolesGroups', res.data)
                    resolve(res)
                }).catch((err) => {
                    console.error(err)
                })
            })
        },
    }
}